import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
//import { AppConsts } from '../models/app-consts';
import { serviceConstants } from 'src/app/constants/service.constants';
//import { ResponseOptions } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  jsonOptions: ResponseOptions = { responseType: "json", withCredentials: true };

  constructor(private http: HttpClient) {
  }

  handleFileUpload(files: FileList): Observable<FileData> {
    if (files && files.length > 0) {
      let file = files.item(0);

      if (file) {
        return this.uploadFile(file);
      }
    }

    return throwError(new Error("No file found to upload"));
  }

  uploadFile(file: File, fileId: string = ''): Observable<FileData> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<FileData>(serviceConstants.apiURL + 'api/File/upload/' + (fileId || ''), formData, this.jsonOptions);
  }

  uploadMultiFiles(formData: FormData, fileId: string = ''): Observable<FileData> {
    return this.http.post<FileData>(serviceConstants.apiURL + 'api/File/SaveTempFile/' + (fileId || ''), formData, this.jsonOptions);
  }

}

export interface FileData {
  FileID?: string;
  FileName?: string;
  FileExt?: string;
  IsFromTemp? : boolean
  FileBytes?: any;
  downloadUrl?: any;
}


export interface ResponseOptions {
  responseType?: 'json';
  withCredentials?: boolean
}